import {
  initState,
  InfraStateType,
} from "#/infra/redux/constants";
import * as actions from "#/infra/redux/actionType";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function infra(
  state: InfraStateType = initState,
  action: { type: string; data?: any },
): InfraStateType {
  const {
    type,
    data,
  } = action;

  switch (type) {
    case actions.SENDING_AXIOS:
      return {
        ...state,
        axiosLoading: true,
        axiosProgress: {},
        axiosResult: {
          success: false,
          msg: "",
          detail: undefined,
        },
      };
    case actions.CLEAN_AXIOS_RESULT:
      return {
        ...state,
        axiosLoading: false,
        axiosResult: {
          success: false,
          msg: "",
          detail: undefined,
        },
      };
    case actions.SET_AXIOS_RESULT:
      return {
        ...state,
        axiosLoading: false,
        axiosResult: data as {
          success: boolean,
          msg: string,
          detail?: Record<string, string>,
        },
      };
    case actions.INTERNAL_ERROR:
      return {
        ...state,
        internalError: data,
      };
    case actions.INFRA_RESIZE:
      return {
        ...state,
        appWidth: data?.appWidth ?? 0,
        appHeight: data?.appHeight ?? 0,
        headerWidth: data?.headerWidth ?? 0,
        headerHeight: data?.headerHeight ?? 0,
      };
    case actions.INFRA_SET_HEADER_SIZE:
      return {
        ...state,
        headerWidth: data?.headerWidth || state.headerWidth,
        headerHeight: data?.headerHeight || state.headerHeight,
      };
    case actions.FETCH_SERVICE_TOKENS:
      return {
        ...state,
        serviceTokens: {
          ...state.serviceTokens,
          loading: true,
        },
      };
    case actions.FETCHED_SERVICE_TOKENS:
      return {
        ...state,
        serviceTokens: {
          loading: false,
          results: data ?? null,
        },
      };
    case actions.FETCH_STATISTICS:
      return {
        ...state,
        statistics: {
          ...state.statistics,
          loading: true,
        },
      };
    case actions.FETCHED_STATISTICS:
      return {
        ...state,
        statistics: {
          ...state.statistics,
          loading: false,
          cache: {
            ...state.statistics.cache,
            [data?.key]: data?.data ?? null,
          },
        },
      };
    default:
      return state;
  }
}

export default infra;
